export default __webpack_public_path__ + "static/media/secret_1.30863a89.jpg";